import { render, staticRenderFns } from "./MenuAccessBlockWatcher.vue?vue&type=template&id=3c456bb5"
import script from "./MenuAccessBlockWatcher.vue?vue&type=script&lang=js"
export * from "./MenuAccessBlockWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c456bb5')) {
      api.createRecord('3c456bb5', component.options)
    } else {
      api.reload('3c456bb5', component.options)
    }
    module.hot.accept("./MenuAccessBlockWatcher.vue?vue&type=template&id=3c456bb5", function () {
      api.rerender('3c456bb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/menuAccessBlock/components/MenuAccessBlockWatcher.vue"
export default component.exports